module.exports = __webpack_public_path__ + "media/images/ns-splashscreen-2021-85879748c31f7316d323b027d779de3a.jpg";